<template>
  <div class="tile is-ancestor">
    <div class="tile is-parent is-10">
      <div class="tile is-child box">
        <p class="subtitle">{{ $t("home.title") }}</p>
        <div class="media">
          <div class="media-content">
            <div class="content" v-for="(text, index) in $t('home.content')">
              <p>
                {{ text }}
              </p>
            </div>
          </div>
        </div>
      </div>
	   <!-- <div class="tile is-child box">
        <p class="title">{{ $t("Features") }}</p>
        <FeatureCarousel/>
      </div> -->
    </div>
  </div>
</template>

<script>
import FeatureCarousel from "@/components/FeatureCarousel.vue";

export default {
	components: { FeatureCarousel },

  data() {
    return {
      document: null,
      queryTerm: "",
      isError: false,
      isReady: false,
    };
  }
};
</script>
